import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import {
  getConversionGrading,
  IConversionGradingReturnType,
} from "api/services/library";
import { Nullable } from "config";
import { RootState } from "store/store";

import {
  ConversionGradingModalMode,
  IConversionGradingModalData,
} from "./types";

const initialState = {
  conversionGradingData: null as Nullable<
    IConversionGradingReturnType["edges"]
  >,
  totalCount: 1,
  loading: false,
  modalData: {
    open: false,
    mode: ConversionGradingModalMode.VIEW,
  } as IConversionGradingModalData,
};

export const fetchConversionGradings = createAsyncThunk(
  "conversionGrading/fetchConversionGradings",
  async (_, { getState }) => {
    const filters = (getState() as RootState).FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const fetchFunction = getConversionGrading;
    const response = await fetchFunction(filters);
    return response;
  }
);

const conversionGradingSlice = createSlice({
  name: "conversionGrading",
  initialState,
  reducers: {
    setConversionGradingModalData: (
      state,
      action: PayloadAction<IConversionGradingModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeConversionGradingModal: (state) => {
      state.modalData = initialState.modalData;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchConversionGradings.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload) {
        state.conversionGradingData = action.payload.edges;
        state.totalCount = action.payload.totalCount;
      }
    });
    builder.addCase(fetchConversionGradings.pending, (state) => {
      state.loading = true;
    });
  },
});

export const { setConversionGradingModalData, closeConversionGradingModal } =
  conversionGradingSlice.actions;

export default conversionGradingSlice.reducer;
